const state = {
  goldClassifications: [{ name: 'Saudi' }, { name: 'Japan' }, { name: 'Italy' }, { name: 'Hong Kong' }, { name: 'Others' }],
  paginationcount: [{ name: '5' }, { name: '10' }, { name: '25' }, { name: '50' }]
};

export default {
  namespaced: true,
  state,
  actions: {
    fetchGoldClassifications({ commit }, payload) {},
    fetchPaginationCount({ commit }, payload) {}
  }
};
